import React from "react";
import Section from "../components/Section";

function Overview() {
  return (
    <Section id="overview" icon="🍽️" title="Overview">
      <p>
        Welcome to <strong>Food-Is</strong>. This Privacy Policy explains how we handle information
        when you use our mobile application ("App") available on iOS and Android.
      </p>
      <div className="highlight-box">
        <strong>Our core commitment:</strong> We do <strong>not</strong> collect, store, or sell
        any personally identifiable information (PII) such as your name, email address, phone number,
        or payment details. Your privacy is fundamental to how we built this App.
      </div>
      <p>
        By using Food-Is, you agree to the practices described in this policy. If you do not agree,
        please discontinue use of the App.
      </p>
    </Section>
  );
}

export default Overview;
